import { styled } from '@mui/material';
import CurrencyInput from 'react-currency-input-field';

interface CurrencyInputProps {
    error?: boolean;
    disabled?: boolean;
}

export function getDefaultCurrencyInputStyledStyles(theme, error, disabled) {
    return {
        border: `thin solid ${theme.palette.primary.main} !important`,
        borderRadius: '8px',
        padding: '18px 12px',
        minWidth: '100px',
        width: '100%',
        height: '100%',
        font: 'inherit',
        '&:hover': {
            border: `1px solid  ${theme.palette.primary.main} !important`,
        },
        ...(error && {
            border: `3px solid  ${theme.palette.error.main} !important`,
            '&:hover': {
                border: `4px solid ${theme.palette.error.main} !important`,
            },
        }),
        ...(disabled && {
            color: theme.palette.text.disabled,
            border: `thin solid ${theme.palette.border.disabled}`,
            '&:hover': {
                border: `thin solid ${theme.palette.grey[600]}`,
            },
        }),
    };
}

export const CurrencyInputStyled = styled(CurrencyInput, {
    shouldForwardProp: (prop) => {
        return prop !== 'error';
    },
})<CurrencyInputProps>(({ error, disabled, theme }) => {
    return getDefaultCurrencyInputStyledStyles(theme, error, disabled);
});

export default CurrencyInputStyled;
